import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { useState, useEffect } from 'react';
import useAxios from '../plugins/useAxios';
import { useNavigate } from "react-router-dom";
import { mapSite } from '../plugins/map.site';
import { ProgressSpinner } from 'primereact/progressspinner';

const ParkingAreaScreen = () => {

    const header = () => {
        return (
            <div className="flex justify-end">
                <span className="p-input-icon-left mr-2">
                    <i className="pi pi-search" />
                    <InputText value={search} onChange={onSearchChange} placeholder="Cerca targa" />
                </span>
                <Button type="button" icon="pi pi-filter-slash" className="p-button-outlined" onClick={clearFilter} />
            </div>
        )
    }

    const hide = (data) => {
        return (
            <div className="cursor-pointer hover:!bg-gray-200 rounded-full transition" onClick={() => hideCar(data)}>
                <i className="pi pi-eraser p-2" />
            </div>
        )
    }

    const date = (data) => {
        return (
            <div>{(new Date(parseInt(data.datetime))).toLocaleString()}</div>
        )
    }

    const counter = (data) => {
        const calcEntranceTime = (timestamp) => {
            var difference = timestamp - Date.now();
            var hours = Math.abs(Math.floor(difference / 1000 / 60 / 60));
            return hours;
        }
        return (
            <div className={'flex items-center'}>
                <div className={'w-4 h-4 rounded-full mr-2 ' + ((calcEntranceTime(data.datetime) > 35) ? 'bg-red-600' : 'bg-green-600')}></div>
                {calcEntranceTime(data.datetime)}
            </div>
        )
    }

    const image = (data) => {
        return (
            <img alt="" src={useAxios.getUri().replace('api/', '') + data.imagePath} />
        )
    }

    const navigate = useNavigate();
    const [filters, setFilters] = useState([]);
    const [search, setSearch] = useState('');
    const [cars, setCars] = useState([]);
    const [first, setFirst] = useState(0); // For pagination
    const [rows, setRows] = useState(50); // Number of rows per page
    const [totalRecords, setTotalRecords] = useState(0);
    const [loading, setLoading] = useState(true); // Loading state for the table

    const footer = `Totale di ${cars ? cars.length : 0} Veicoli.`;

    const clearFilter = () => {
        setFilters([]);
    }

    const onSearchChange = (e) => {
        setSearch(e.target.value);
        let filteredCars = cars.filter(car => car.plate.includes(search.toUpperCase()));
        setFilters(filteredCars);
    }

    const hideCar = (car) => {
        useAxios.post('car/' + car._id, car).then(res => {
            let filtered = cars.filter(item => item._id !== car._id);
            let _filtered = filters.filter(item => item._id !== car._id);
            setCars(filtered);
            setFilters(_filtered);
        })
    }

    const onPageChange = (e) => {
        setFirst(e.first);
        setRows(e.rows);
        const page = e.first / e.rows; // Calculate the page index
        loadCars(page, e.rows); // Call the function to load cars
    };

    const loadCars = (page, pageSize) => {
        setLoading(true); // Set loading to true before fetching the data
        const tagName = localStorage.getItem('site');
        useAxios.get(`parking?tagName=${tagName}&page=${page}&pageSize=${pageSize}&q=${search}`)
            .then((res) => {
                setCars(res.data.data);
                setFilters(res.data.data);
                setTotalRecords(res.data.totalRecords);
                setLoading(false); // Set loading to false after data is fetched
            })
            .catch(err => {
                console.error(err);
                setLoading(false); // Set loading to false even if an error occurs
            });
    };

    const reloadData = () => {
        // Reset query and pagination
        setSearch('');
        setFilters([]);
        setFirst(0); // Go back to the first page
        loadCars(0, rows); // Reload cars data
    };

    useEffect(() => {
        const tagName = localStorage.getItem('site');
        if (!tagName) {
            navigate('/sites');
            return;
        }

        loadCars(0, rows);
    }, []);

    return (
        <div className="lg:p-12 p-6">
            <div className="flex justify-between items-center mb-8">
                <div className="text-3xl font-bold mb-12">Veicoli {mapSite(localStorage.getItem('site'))}</div>
                <Button type="button" label="Aggiorna" icon="pi pi-refresh" onClick={reloadData} className="p-button-outlined mb-4" />
            </div>

            <div className="datatable-templating">

                {loading ? (
                    <div className="flex justify-center">
                        <ProgressSpinner /> {/* Display loading spinner */}
                    </div>
                ) : (
                    <DataTable
                        value={(search !== '') ? filters : cars}
                        header={header}
                        footer={footer}
                        responsiveLayout="stack"
                        paginator={true}
                        rows={rows}
                        first={first}
                        lazy
                        onPage={onPageChange}
                        totalRecords={totalRecords}
                        emptyMessage="Nessun veicolo nel parcheggio"
                    >
                        <Column field="plate" header="Targa"></Column>
                        <Column field="country" header="Paese"></Column>
                        <Column field="datetime" header="Orario d'ingresso" body={date}></Column>
                        <Column field="datetime" header="Dentro da (h)" body={counter}></Column>
                        <Column field="image" header="Immagine" body={image}></Column>
                        <Column field="id" header="Elimina" body={hide}></Column>
                    </DataTable>
                )}
            </div>
        </div>
    );
};

export default ParkingAreaScreen;
